"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CycleInterval = void 0;
const date_utils_1 = require("./date-utils");
const ValueObject_1 = require("./ValueObject");
class CycleInterval extends ValueObject_1.ValueObject {
    timeZone;
    constructor(props) {
        if (props.start > props.end) {
            throw new Error("Start date must be before end date");
        }
        super(props);
        this.timeZone = props.timeZone ?? date_utils_1.PACIFIC_TIME_ZONE;
    }
    get start() {
        return this.props.start;
    }
    get end() {
        return this.props.end;
    }
    isBetween(date) {
        return this.start <= date && date <= this.end;
    }
    equals(other) {
        return (this.start.getTime() === other.start.getTime() &&
            this.end.getTime() === other.end.getTime());
    }
    static create(strStart, strEnd, timeZone = date_utils_1.PACIFIC_TIME_ZONE) {
        const start = (0, date_utils_1.getZonedStartOfDay)((0, date_utils_1.parseDateString)(strStart), timeZone);
        const end = (0, date_utils_1.getZonedEndOfDay)((0, date_utils_1.parseDateString)(strEnd), timeZone);
        return new CycleInterval({ start, end, timeZone });
    }
    cycleFinished() {
        return this.end < new Date();
    }
    format() {
        return {
            start: (0, date_utils_1.formatZonedDate)(this.start, "yyyy-MM-dd", this.timeZone),
            end: (0, date_utils_1.formatZonedDate)(this.end, "yyyy-MM-dd", this.timeZone),
            label: `${(0, date_utils_1.formatZonedDate)(this.start, "MMM d", this.timeZone)} - ${(0, date_utils_1.formatZonedDate)(this.end, "MMM d", this.timeZone)}`,
        };
    }
}
exports.CycleInterval = CycleInterval;
//# sourceMappingURL=cycle-interval.js.map